import ListItem from './components/ListItem';
import { type EditorPlugin } from '../../types/aha-editor';

const ListItemPlugin: EditorPlugin = {
  name: 'List Item component plugin',
  component: {
    type: 'list_item',
    component: ListItem,
  },
};

export default ListItemPlugin;
